import React from 'react';
import './About.css';
import SEO from "../components/SEO";
import { motion } from 'framer-motion';

function About() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
    <>
    <SEO
      title="Chi Siamo | Andolfatto Insurance Broker"
      description="Dal 1974 la famiglia Andolfatto offre consulenza assicurativa indipendente. Uniamo esperienza e innovazione per garantire libertà, trasparenza e protezione su misura per privati, professionisti e aziende."
      url="https://andolfattobroker.it/chi-siamo"
    />

      <main className="about-page">
        <section className="about-hero">
          <div className="about-content">
            <h1>Chi Siamo</h1>
            {/* 🔽 H2 nascosti SEO-friendly */}
            <h2 className="visually-hidden">
              Storia e valori di Andolfatto Insurance Broker dal 1974.
            </h2>

            <h2 className="visually-hidden">
              Esperienza familiare nel settore assicurativo e indipendenza professionale.
            </h2>

            <h2 className="visually-hidden">
              Consulenza assicurativa trasparente per privati, professionisti e imprese.
            </h2>

            <h2 className="visually-hidden">
              Analisi dei rischi, soluzioni personalizzate e gestione sinistri continua.
            </h2>
            <p className="about-intro">
              Dal 1974 la nostra famiglia opera nel settore dell'intermediazione assicurativa,
              offrendo consulenza qualificata e soluzioni personalizzate per privati,
              professionisti e aziende.
            </p>
          </div>
        </section>

        <section className="about-story">
          <div className="story-content">
            <p>
              Per quasi cinquant'anni abbiamo gestito un'agenzia monomandataria di una primaria
              compagnia assicurativa, esperienza che ci ha permesso di acquisire competenze
              approfondite e una conoscenza diretta delle dinamiche del mercato.
            </p>

            <p>
              Nel 2023 abbiamo scelto di diventare broker assicurativi indipendenti per garantire
              ai nostri clienti più libertà di scelta, coperture realmente su misura e l'accesso
              alle migliori soluzioni disponibili, senza vincoli verso una singola compagnia.
              È stato un cambiamento importante per offrire ancora più trasparenza, qualità e
              tutela degli interessi di chi si affida a noi.
            </p>

            <p>
              Oggi uniamo l'esperienza maturata in decenni di lavoro a una costante attenzione
              all'innovazione, operando con competenza, precisione e massima cura delle esigenze
              di ogni cliente. Collaboriamo con le principali compagnie assicurative nazionali
              e internazionali, mantenendo piena indipendenza operativa.
            </p>
          </div>

          <div className="our-method">
            <h2>La Nostra Proposta</h2>
            <ul>
              <li>Analisi accurata di rischi e bisogni assicurativi</li>
              <li>Selezione delle migliori soluzioni sul mercato</li>
              <li>Assistenza continuativa e gestione sinistri</li>
            </ul>

            <p className="conclusion">
              Scegliere Andolfatto Insurance Broker significa affidarsi a un partner solido, professionale
              e orientato alla qualità, capace di offrire un servizio puntuale, trasparente e su misura.
            </p>
          </div>
        </section>
      </main>
    </>
  </motion.div>
  );
}

export default About;